<div class="root-wrapper">
    <div class="fixed-top">
        <app-global-header></app-global-header>
    </div>
    
    <div [@routeAnimations]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
</div>